<script lang="ts">
    import GameTokenScheme from './game-token-scheme.png'
    import GameTokenScheme1 from './game-token-scheme-1.png'
    import GameTokenScheme2 from './game-token-scheme-2.png'
    import GameTokenScheme3 from './game-token-scheme-3.png'
    import GameTokenScheme4 from './game-token-scheme-4.png'
    import GameTokenScheme5 from './game-token-scheme-5.png'
</script>

<section class="game-token-scheme d-none d-md-block" style="
    --GameTokenScheme2:url({GameTokenScheme2});
">
    <div class="container">
        <div class="row">
            <div class="offset-md-4 col-md-4 text-center">
                <div class="label item-0">Game Shop</div>
                <img src="{GameTokenScheme1}" alt="">
            </div>
        </div>
        <div class="row">
            <div class="col-md-4">
                <div class="label item-1">LootBox</div>
                <div class="label item-2">Game Items</div>
            </div>
            <div class="col-md-4 text-center">
                <div class="circle">Game</div>
                <img src="{GameTokenScheme1}" alt="">
            </div>
            <div class="col-md-4">
                <div class="label item-3">Hero Upgrade</div>
                <div class="label item-4">NFT Marketplace</div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-4">
                <div class="label item-5">Payment Transactions</div>
            </div>
            <div class="col-md-4 text-center">
                <div class="circle">LIS Token</div>
                <img src="{GameTokenScheme1}" class="rotate-180" alt="">
            </div>
            <div class="col-md-4">
                <div class="label item-6">Governance</div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-4"></div>
            <div class="col-md-4 text-center">
                <div class="label item-7">Staking</div>
            </div>
            <div class="col-md-4"></div>
        </div>
    </div>
</section>
<section class="game-token-scheme d-md-none" style="
    --GameTokenScheme:url({GameTokenScheme});
    --GameTokenScheme3:url({GameTokenScheme3});
    --GameTokenScheme5:url({GameTokenScheme5});
">
    <div class="container">
        <div id="game-token-scheme-mobile-slider">
            <div class="game-token-scheme-mobile">
                <div>
                    <div class="label item-0">Hero Upgrade</div>
                    <div class="label item-1">Game Shop</div>
                    <div class="label item-2">LootBox</div>
                </div>
                <div>
                    <div class="circle">Game</div>
                </div>
                <div>
                    <div class="label item-3">NFT Marketplace</div>
                    <div class="label item-4"><img src="{GameTokenScheme4}" alt=""></div>
                    <div class="label item-5">Game Items</div>
                </div>
                <div>
                    <div class="circle">LIS Token</div>
                </div>
                <div>
                    <div class="label item-6">Governance</div>
                    <div class="label item-7"><img src="{GameTokenScheme4}" class="rotate-180" alt=""></div>
                    <div class="label item-8">Payment Transactions</div>
                </div>
                <div>
                    <div class="label item-9">Staking</div>
                </div>
            </div>
        </div>
    </div>
</section>

<style lang="postcss">
    @import "../../../../../styles/global/scrollbar.pcss";

    #game-token-scheme-mobile-slider {
        @include scrollbar;
        @include scroll-smooth;
    }

    .game-token-scheme {
        margin: 120px auto;
        max-width: 1134px;
    }

    .label {
        background: #212121;
        border-radius: 6px;
        margin: 10px auto;
        width: 216px;
        color: white;
        height: 64px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 20px;
        border: 2px dashed #FF951C;
        white-space: nowrap;
        min-width: 287px;
        position: relative;
    }

    .label {
        background: #212121;
        border-radius: 6px;
        margin: 10px auto;
        width: 216px;
        color: white;
        height: 64px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 20px;
        border: 2px dashed #FF951C;
        white-space: nowrap;
        min-width: 287px;
        position: relative;
    }

    .label.item-1 {
        margin-top: 45px;
        margin-left: 0;
    }

    .label.item-1:after {
        content: "";
        background: var(--GameTokenScheme2) no-repeat;
        position: absolute;
        width: 156px;
        height: 38px;
        left: 100%;
        margin: 10px 0 0 20px;
    }

    .label.item-2 {
        margin-left: 0;
    }

    .label.item-2:after {
        content: "";
        background: var(--GameTokenScheme2) no-repeat;
        position: absolute;
        width: 156px;
        height: 38px;
        left: 100%;
        margin: -10px 0 0 20px;
        transform: rotate(-10deg);
    }

    .circle {
        background: #212121;
        width: 180px;
        height: 180px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        color: white;
        font-size: 20px;
        font-weight: 400;
        margin: 25px auto;
        z-index: 2;
        position: relative;
        border: 5px solid #FF5D1C;
    }

    .label.item-3 {
        margin-top: 45px;
        margin-right: 0;
    }

    .label.item-3:after {
        content: "";
        background: var(--GameTokenScheme2) no-repeat;
        position: absolute;
        width: 156px;
        height: 38px;
        right: 100%;
        margin: 10px 18px 0 0;
        transform: rotate(168deg);
    }

    .label.item-4 {
        margin-right: 0;
    }

    .label.item-4:after {
        content: "";
        background: var(--GameTokenScheme2) no-repeat;
        position: absolute;
        width: 156px;
        height: 38px;
        right: 100%;
        margin: -12px 18px 0 0;
        transform: rotate(180deg);
    }

    .label.item-5 {
        margin-top: 78px;
        margin-left: 0;
    }

    .label.item-5:after {
        content: "";
        background: var(--GameTokenScheme2) no-repeat;
        position: absolute;
        width: 156px;
        height: 38px;
        left: 100%;
        margin: 5px 0 0 12px;
        transform: rotate(-5deg);
    }

    .label.item-5 {
        margin-top: 65px;
        margin-left: 0;
    }

    .label.item-6 {
        margin-top: 78px;
        margin-right: 0;
    }

    .label.item-6:after {
        content: "";
        background: var(--GameTokenScheme2) no-repeat;
        position: absolute;
        width: 156px;
        height: 38px;
        right: 100%;
        margin: 5px 12px 0 0;
        transform: rotate(175deg);
    }

    .label.item-7 {
        margin-top: 22px;
    }

    @media (max-width: 992px) {
        .game-token-scheme .label {
            font-size: 16px;
            min-width: 100%;
        }

        .game-token-scheme .circle {
            font-size: 18px;
            z-index: 2;
            position: relative;
        }

        .label.item-5 {
            margin-top: 78px;
        }
    }

    @media (max-width: 767px) {
        .game-token-scheme-mobile {
            display: flex;
            align-items: center;
        }

        .game-token-scheme-mobile .label {
            width: 213px;
            min-width: 213px;
            height: 54px;
            border: 3px dashed #ff951c;
            margin: 36px 150px;
        }

        .game-token-scheme .label.item-0:after {
            content: "";
            background: var(--GameTokenScheme) no-repeat;
            position: absolute;
            width: 156px;
            height: 38px;
            left: 100%;
            margin: 25px 0 0 20px;
        }

        .game-token-scheme .label.item-1:after {
            content: "";
            background: var(--GameTokenScheme) no-repeat;
            position: absolute;
            width: 156px;
            height: 38px;
            left: 100%;
            margin: 25px 0 0 20px;
        }

        .game-token-scheme .label.item-2:after {
            content: "";
            background: var(--GameTokenScheme) no-repeat;
            position: absolute;
            width: 156px;
            height: 38px;
            left: 100%;
            margin: 25px 0 0 20px;
            transform: none;
        }

        .game-token-scheme .label.item-3:after {
            content: "";
            background: var(--GameTokenScheme3) no-repeat;
            position: absolute;
            width: 60px;
            height: 38px;
            right: 100%;
            margin: 25px 18px 0 0;
            transform: none;
        }

        .game-token-scheme .label.item-5:after {
            content: "";
            background: var(--GameTokenScheme5) no-repeat;
            position: absolute;
            width: 60px;
            height: 38px;
            right: 100%;
            left: auto;
            margin: 25px 18px 0 0;
            transform: none;
        }

        .game-token-scheme .label.item-6:after {
            content: "";
            background: var(--GameTokenScheme2) no-repeat;
            position: absolute;
            width: 60px;
            height: 38px;
            right: 100%;
            left: auto;
            margin: 25px 18px 0 0;
            transform: none;
        }

        .game-token-scheme .label.item-8:after {
            content: "";
            background: var(--GameTokenScheme5) no-repeat;
            position: absolute;
            width: 60px;
            height: 38px;
            right: 100%;
            left: auto;
            margin: 25px 18px 0 0;
            transform: none;
        }

        #game-token-scheme-mobile-slider {
            overflow: auto;
            padding: 0 0 20px;
        }

        .game-token-scheme .circle {
            font-size: 16px;
            width: 234px;
            height: 234px;
            margin: 0;
        }

        .game-token-scheme .label.item-3,
        .game-token-scheme .label.item-4,
        .game-token-scheme .label.item-5,
        .game-token-scheme .label.item-6,
        .game-token-scheme .label.item-7,
        .game-token-scheme .label.item-8 {
            margin: 36px 60px;
        }

        .game-token-scheme {
            margin: 60px 0;
        }

        .game-token-scheme .label.item-4,
        .game-token-scheme .label.item-7 {
            border-color: transparent;
        }

        .game-token-scheme .label.item-0,
        .game-token-scheme .label.item-3,
        .game-token-scheme .label.item-6 {
            margin-top: 0;
        }

        .game-token-scheme .label.item-0,
        .game-token-scheme .label.item-1,
        .game-token-scheme .label.item-2 {
            margin-left: 0;
        }

        .game-token-scheme .label.item-2,
        .game-token-scheme .label.item-5,
        .game-token-scheme .label.item-8 {
            margin-bottom: 0;
        }

        .game-token-scheme .label.item-9 {
            margin: 0;
        }
    }
</style>
